import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const PowerFilterFrame = styled.div`
  padding: 24px;
`;

export const PowerFilterWrapper = styled.div`
  display: flex;
  font-family: Audi Type;
  flex-direction: column;
  gap: 24px;
  @media ${device.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Two columns, each taking 50% of the width */
    gap: 23px;
  }
  // overwrite label option of Select audi ui react library component
  .hasValue {
    label:not(:focus-within) {
      animation-name: none;
    }
  }
`;
